module.exports = __webpack_public_path__ + "3d188dd80a0b4d21e5b86e91c27dc70e.png";